import { state } from "@/store/onboarding/state"
import { mutations } from "@/store/onboarding/mutations"
import { getters } from "@/store/onboarding/getters"
import { actions } from "@/store/onboarding/actions"

export default {
  namespaced: true,
  state,
  mutations,
  getters,
  actions
}
